import React, {Suspense} from 'react'
import styles from './styles.module.css'
import {useState} from '@hooks/useState'
import CartMenu from './CartMenu'
import Content from '@page-components/Order/Cart/Content'
import UpdateBasicOptions from '../Options/UpdateBasicOptions'
import OptionsLabel from './OptionsLabel'
import {sendPosthogData, EVENTS} from '@helpers/posthog'
import {useEffect} from '@hooks/useEffect'
import {useTranslation} from 'next-i18next'
import Skeleton from './Skeleton'
import {useOnEvent} from 'react-app-events'

export default function CartMenuV2(props) {
  const {preferences, website, layout, loading} = props
  const [open, setOpen] = useState(false)
  const [openOptions, setOpenOptions] = useState(false)
  const [hiddenPrice, setHiddenPrice] = useState(false)
  const {t} = useTranslation('website', {keyPrefix: 'order'})

  useEffect(() => {
    if (!loading && !preferences.store) {
      setOpenOptions(true)
    }
  }, [loading])

  useEffect(() => {
    setHiddenPrice(false)
  }, [preferences])

  useOnEvent('hiddenPriceProductOpened', async () => {
    setOpenOptions(true)
    setHiddenPrice(true)
  })

  return (
    <>
      <CartMenu
        open={open}
        openOptions={openOptions}
        forceOpenOptions={!preferences.store}
        onClick={() => {
          sendPosthogData(EVENTS.clicked.cart, {open: !open})
          setTimeout(() => setOpen(!open))
        }}
        setOpenOptions={() => {
          setTimeout(() => setOpenOptions(!openOptions))
        }}
        cart={preferences.cart}
        optionsLabel={<OptionsLabel preferences={preferences} />}
        options={
          <div className={`${styles.options} ${hiddenPrice ? styles.hiddenPrice : ''}`}>
            <div className={styles.title}>{t('cartMenuV2.labelOptionsTitle')}</div>
            {hiddenPrice ? (
              <p>Necesitamos tu dirección para poder continuar con el pedido</p>
            ) : null}
            <div className={styles.optionsContent}>
              <UpdateBasicOptions preferences={preferences} />
            </div>
          </div>
        }>
        <div className={styles.container}>
          <div className={styles.title}>{t('titleMyOrder')}</div>
          {preferences.cart ? (
            <Content preferences={preferences} website={website} layout={layout} />
          ) : (
            <Skeleton />
          )}
        </div>
      </CartMenu>
    </>
  )
}
